// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer-global {
  width: 100%;
  background: #fff;
  border-top: 1px solid #dbdbdb;
  color: #67717f;
  float: none;
  font-size: 0;
  margin: 100px 0 0 0;
  padding: 0;
  position: relative;
  overflow: hidden;
  opacity: 1;
}

@media only screen and (min-width: 1024px) {
  .footer-global {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
.footer-global.fixed {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
}

.footer-global .admin-links,
.footer-global .licence-copyright,
.footer-global .message {
  display: block;
  padding: 5px 0;
  position: relative;
  vertical-align: middle;
}

.footer-global .message {
  text-align: center;
  white-space: normal;
}

@media only screen and (min-width: 1024px) {
  .footer-global .admin-links,
.footer-global .licence-copyright,
.footer-global .message {
    display: inline-block;
    height: 100%;
    padding: 20px 0;
  }

  .footer-global .message {
    width: calc(100% - 550px) !important;
    text-align: left;
    vertical-align: middle;
  }

  .footer-global .footer-license-wrapper {
    display: flex;
    align-items: center;
  }
}
.footer-global .message .message-info {
  width: 100%;
  display: inline-block;
  font-size: 14px;
  font-weight: 300;
  margin: 0;
  padding-left: 30px;
  padding-right: 30px;
  position: relative;
  text-align: center;
  vertical-align: middle;
  white-space: normal;
}

.footer-global .message .message-info * {
  display: inline-block;
  margin: 0;
  padding: 0;
}

@media only screen and (min-width: 1024px) {
  .footer-global .message .message-info {
    width: auto;
    font-size: 16px;
    padding-left: 51px;
    padding-right: 10px;
    text-align: left;
  }
}
.footer-global .message .message-info .action-button {
  display: inline-block;
  width: 100%;
  text-align: center;
}

.footer-global .message .message-info .action-button button {
  width: auto;
  background: #fff;
  border: 1px solid #1b88e7;
  border-radius: 4px;
  color: #1b88e7;
  display: inline-block;
  font-size: 12px;
  line-height: 30px;
  margin: 5px 0 0;
  padding: 0 10px;
  text-align: center;
  white-space: nowrap;
}

.footer-global .message .message-info .action-button button:hover {
  background: #1b88e7;
  color: #fff;
}

.footer-global .admin-links,
.footer-global .licence-copyright {
  padding-left: 10px;
  padding-right: 10px;
  text-align: center;
  white-space: normal;
}

@media only screen and (min-width: 1024px) {
  .footer-global .message .message-info .action-button {
    width: auto;
    position: absolute;
    right: 10px;
    top: 50%;
    -webkit-transform: translate(0, -50%);
    -moz-transform: translate(0, -50%);
    -ms-transform: translate(0, -50%);
    -o-transform: translate(0, -50%);
  }

  .footer-global .message .message-info .action-button button {
    margin: 0 0 0 10px;
  }

  .footer-global .admin-links,
.footer-global .licence-copyright {
    text-align: left;
  }
}
.footer-global .admin-links {
  position: relative;
}

.footer-global .admin-links a {
  width: 100%;
  color: #004693;
  display: block;
  font-size: 12px;
  white-space: normal;
}

.footer-global .admin-links a:hover {
  color: #0095dc;
}

.footer-global .licence-copyright {
  background: #fafafa;
  font-size: 12px;
  font-weight: 400;
  margin: 0;
  padding: 8px 15px 8px 0;
  z-index: 0;
}

.footer-global .licence-copyright:after {
  height: 500px;
  background: #fafafa;
  left: 0;
  position: absolute;
  top: 50%;
  right: -500px;
  z-index: -1;
}

.footer-global .licence-copyright div,
.footer-global .licence-copyright span {
  width: 100%;
  display: inline-block;
  font-size: 12px;
  font-weight: 300;
  text-align: center;
  white-space: normal;
}

@media only screen and (min-width: 1024px) {
  .footer-global .licence-copyright {
    padding: 20px 65px 20px 20px;
  }

  .footer-global .licence-copyright:after {
    content: "";
  }

  .footer-global .licence-copyright div,
.footer-global .licence-copyright span {
    text-align: left;
  }
}
.footer-global .licence-copyright div:first-of-type,
.footer-global .licence-copyright span:first-of-type {
  display: block;
  font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/styles/scss/footer.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,gBAAA;EACA,6BAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;AACJ;;AACA;EACI;IACI,aAAA;IACA,mBAAA;IACA,8BAAA;EAEN;AACF;AAAA;EACI,eAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;AAEJ;;AAAA;;;EAGI,cAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;AAGJ;;AADA;EACI,kBAAA;EACA,mBAAA;AAIJ;;AAFA;EACI;;;IAGI,qBAAA;IACA,YAAA;IACA,eAAA;EAKN;;EAHE;IACI,oCAAA;IACA,gBAAA;IACA,sBAAA;EAMN;;EAJE;IACI,aAAA;IACA,mBAAA;EAON;AACF;AALA;EACI,WAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;AAOJ;;AALA;EACI,qBAAA;EACA,SAAA;EACA,UAAA;AAQJ;;AANA;EACI;IACI,WAAA;IACA,eAAA;IACA,kBAAA;IACA,mBAAA;IACA,gBAAA;EASN;AACF;AAPA;EACI,qBAAA;EACA,WAAA;EACA,kBAAA;AASJ;;AAPA;EACI,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;AAUJ;;AARA;EACI,mBAAA;EACA,WAAA;AAWJ;;AATA;;EAEI,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AAYJ;;AAVA;EACI;IACI,WAAA;IACA,kBAAA;IACA,WAAA;IACA,QAAA;IACA,qCAAA;IACA,kCAAA;IACA,iCAAA;IACA,gCAAA;EAaN;;EAXE;IACI,kBAAA;EAcN;;EAZE;;IAEI,gBAAA;EAeN;AACF;AAbA;EACI,kBAAA;AAeJ;;AAbA;EACI,WAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;AAgBJ;;AAdA;EACI,cAAA;AAiBJ;;AAfA;EACI,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;EACA,uBAAA;EACA,UAAA;AAkBJ;;AAhBA;EACI,aAAA;EACA,mBAAA;EACA,OAAA;EACA,kBAAA;EACA,QAAA;EACA,aAAA;EACA,WAAA;AAmBJ;;AAjBA;;EAEI,WAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AAoBJ;;AAlBA;EACI;IACI,4BAAA;EAqBN;;EAnBE;IACI,WAAA;EAsBN;;EApBE;;IAEI,gBAAA;EAuBN;AACF;AArBA;;EAEI,cAAA;EACA,eAAA;AAuBJ","sourcesContent":[".footer-global {\n    width: 100%;\n    background: #fff;\n    border-top: 1px solid #dbdbdb;\n    color: #67717f;\n    float: none;\n    font-size: 0;\n    margin: 100px 0 0 0;\n    padding: 0;\n    position: relative;\n    overflow: hidden;\n    opacity: 1;\n}\n@media only screen and (min-width: 1024px) {\n    .footer-global {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n    }\n}\n.footer-global.fixed {\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    right: 0;\n}\n.footer-global .admin-links,\n.footer-global .licence-copyright,\n.footer-global .message {\n    display: block;\n    padding: 5px 0;\n    position: relative;\n    vertical-align: middle;\n}\n.footer-global .message {\n    text-align: center;\n    white-space: normal;\n}\n@media only screen and (min-width: 1024px) {\n    .footer-global .admin-links,\n    .footer-global .licence-copyright,\n    .footer-global .message {\n        display: inline-block;\n        height: 100%;\n        padding: 20px 0;\n    }\n    .footer-global .message {\n        width: calc(100% - 550px) !important;\n        text-align: left;\n        vertical-align: middle;\n    }\n    .footer-global .footer-license-wrapper {\n        display: flex;\n        align-items: center;\n    }\n}\n.footer-global .message .message-info {\n    width: 100%;\n    display: inline-block;\n    font-size: 14px;\n    font-weight: 300;\n    margin: 0;\n    padding-left: 30px;\n    padding-right: 30px;\n    position: relative;\n    text-align: center;\n    vertical-align: middle;\n    white-space: normal;\n}\n.footer-global .message .message-info * {\n    display: inline-block;\n    margin: 0;\n    padding: 0;\n}\n@media only screen and (min-width: 1024px) {\n    .footer-global .message .message-info {\n        width: auto;\n        font-size: 16px;\n        padding-left: 51px;\n        padding-right: 10px;\n        text-align: left;\n    }\n}\n.footer-global .message .message-info .action-button {\n    display: inline-block;\n    width: 100%;\n    text-align: center;\n}\n.footer-global .message .message-info .action-button button {\n    width: auto;\n    background: #fff;\n    border: 1px solid #1b88e7;\n    border-radius: 4px;\n    color: #1b88e7;\n    display: inline-block;\n    font-size: 12px;\n    line-height: 30px;\n    margin: 5px 0 0;\n    padding: 0 10px;\n    text-align: center;\n    white-space: nowrap;\n}\n.footer-global .message .message-info .action-button button:hover {\n    background: #1b88e7;\n    color: #fff;\n}\n.footer-global .admin-links,\n.footer-global .licence-copyright {\n    padding-left: 10px;\n    padding-right: 10px;\n    text-align: center;\n    white-space: normal;\n}\n@media only screen and (min-width: 1024px) {\n    .footer-global .message .message-info .action-button {\n        width: auto;\n        position: absolute;\n        right: 10px;\n        top: 50%;\n        -webkit-transform: translate(0, -50%);\n        -moz-transform: translate(0, -50%);\n        -ms-transform: translate(0, -50%);\n        -o-transform: translate(0, -50%);\n    }\n    .footer-global .message .message-info .action-button button {\n        margin: 0 0 0 10px;\n    }\n    .footer-global .admin-links,\n    .footer-global .licence-copyright {\n        text-align: left;\n    }\n}\n.footer-global .admin-links {\n    position: relative;\n}\n.footer-global .admin-links a {\n    width: 100%;\n    color: #004693;\n    display: block;\n    font-size: 12px;\n    white-space: normal;\n}\n.footer-global .admin-links a:hover {\n    color: #0095dc;\n}\n.footer-global .licence-copyright {\n    background: #fafafa;\n    font-size: 12px;\n    font-weight: 400;\n    margin: 0;\n    padding: 8px 15px 8px 0;\n    z-index: 0;\n}\n.footer-global .licence-copyright:after {\n    height: 500px;\n    background: #fafafa;\n    left: 0;\n    position: absolute;\n    top: 50%;\n    right: -500px;\n    z-index: -1;\n}\n.footer-global .licence-copyright div,\n.footer-global .licence-copyright span {\n    width: 100%;\n    display: inline-block;\n    font-size: 12px;\n    font-weight: 300;\n    text-align: center;\n    white-space: normal;\n}\n@media only screen and (min-width: 1024px) {\n    .footer-global .licence-copyright {\n        padding: 20px 65px 20px 20px;\n    }\n    .footer-global .licence-copyright:after {\n        content: \"\";\n    }\n    .footer-global .licence-copyright div,\n    .footer-global .licence-copyright span {\n        text-align: left;\n    }\n}\n.footer-global .licence-copyright div:first-of-type,\n.footer-global .licence-copyright span:first-of-type {\n    display: block;\n    font-size: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
